import { cva, type VariantProps } from "class-variance-authority";

/**
 * Variants Tailwind partagés du composant `Button` (shadcn/ui).
 *
 * Extrait dans son propre fichier pour respecter la règle ESLint
 * `react-refresh/only-export-components` (un fichier composant ne peut
 * exporter que des composants).
 *
 * Note contraste WCAG AA (S3-11) : la variante `default` utilise
 * `bg-primary` (ambre #f59e0b) + `text-primary-foreground` (blanc), qui ne
 * satisfait pas le ratio 4.5:1 ; on bascule le texte sur un foreground
 * sombre via `--primary-foreground` (cf. `index.css`).
 */
export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-6",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export type ButtonVariantProps = VariantProps<typeof buttonVariants>;
